<template>
    <a-select class="outterselect" mode="multiple" style="width: 210px" v-model="val" 
        :placeholder="placeholder" 
        :maxTagCount=0  
        :maxTagPlaceholder="maxTagPlaceholder"
        allowClear
        @change="changeHandler">
        <div slot="dropdownRender" slot-scope="menu" @mousedown="e=>e.preventDefault()">
            <v-nodes :vnodes="menu" />
            <a-divider style="margin: 4px 0;" />
            <div style="padding: 8px; cursor: pointer;"><a-checkbox @change="selectAll">{{$t("pageHeader.checkAll")}}</a-checkbox></div>
        </div>
        <template v-for="(option, oindex) in options">
            <a-select-opt-group v-if="option.options" :label="option.label" :key="oindex" >
                <a-select-option :value="suboption.value" v-for="suboption in option.options" :key="suboption.value">{{suboption.label}}</a-select-option>
            </a-select-opt-group>
            <a-select-option :value="option.value" v-if="!(option.options)" :key="oindex">{{option.label}}</a-select-option>
        </template>
    </a-select>
</template>

<script>
import {Select} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Select)

export default {
    components: {
        Select,
        VNodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes,
        },
    }, 
    props:['placeholder', 'label', 'value', 'options'],
    data() {
        return {
            val: [],
            maxTagPlaceholder: (e,v)=> {
                return this.$t("common.selected") + `${v._props.value.length}${this.$i18n.locale == "zh_CN" ? "项" : ""}`;
            }
        }
    },
    mounted() {
        if(this.value) {
            this.val = [].concat(this.value)
        }
    },
    watch: {
        value(val) {
            this.val = [].concat(val)
        }
    },
    computed: {
        allvalue() {
            let all = []
            this.options.forEach((option)=>{
                if(option.options) {
                    option.options.forEach((sub)=>{
                        all.push(sub.value)
                    })
                } else {
                    all.push(option.value)
                }
            })
            return all
        }
    },
    methods: {
        changeHandler(vals) {
            this.$emit('input', vals)
        },
        selectAll(e) {
            if(e.target.checked==true) {
                this.val = [].concat(this.allvalue)
            }
            else {
                this.val = []
            }
            this.$emit('input', this.val)
        },
    }

}
</script>

<style lang="less">
.outterselect.ant-select .ant-select-selection--multiple .ant-select-selection__choice {
    background: none;
    border:none;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.65);
    margin-top: 4px;
}
</style>